import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { Topbar } from "../Components/Topbar";
import { Sidebar } from "../Components/Sidebar";

import { Dashboard } from "./Dashboard/Dashboard";
import { Attendance } from "./Attendance/Attendance";
import { Earnings } from "./Earnings/Earnings";
import { Engage } from "./Engage/Engage";
import { HelpDesk } from "./HelpDesk/HelpDesk";
import { MyProfile } from "./MyProfile/MyProfile";
import ProfilePage from "./ProfilePage";
import { Approvals } from "./Approvals/Approvals";
import { CompanyPolicies } from "./CompanyPolicies/CompanyPolicies";
import { TicketDetail } from "./HelpDesk/TicketDetail";

import PersonalInfo from "./MyProfile/profile/PersonalInfo";
import PreviousEmployment from "./MyProfile/profile/PreviousEmployment";
import AccoundStationary from "./MyProfile/profile/AccoundStationary";
import NominationDetails from "./MyProfile/profile/NominationDetails";
import Documents from "./MyProfile/profile/Documents";
import FamilyDetails from "./MyProfile/profile/FamilyDetails";
import { Loader } from "lucide-react";
import ScrollToTop from "../Components/ScrollUpTo";
import CompanyAssets from "./CompanyAssets";
import TDS from "./TDS/TDS";

export const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar (Static Left) */}
      <Sidebar />

      {/* Right Content Area */}
      <div className="flex-1 min-w-0">
        {/* Topbar */}
        <Topbar />

        {/* Main content with correct padding/spacing */}
        <main className="pt-16 md:ml-64  overflow-x-hidden max-w-full">
          <Suspense fallback={<Loader />}>
            <ScrollToTop />
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              {/* <Route path="/attendance" element={<Attendance />} /> */}
              {/* <Route path="/attendance/*" element={<Attendance />} /> */}
              <Route path="/attendance/*" element={<Attendance />} />
              <Route path="/payslips" element={<Earnings />} />
              <Route path="/engage" element={<Engage />} />
              <Route path="/help-desk" element={<HelpDesk />} />
              <Route path="/my-profile" element={<MyProfile />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/company-assets/*" element={<CompanyAssets />} />
              {/* Profile Subroutes (If needed later) */}
              <Route
                path="/my-profile/personal-info"
                element={<PersonalInfo />}
              />
              <Route
                path="/my-profile/previous-employment"
                element={<PreviousEmployment />}
              />
              <Route
                path="/my-profile/account-stationary"
                element={<AccoundStationary />}
              />
              <Route
                path="/my-profile/nomination-details"
                element={<NominationDetails />}
              />
              <Route path="/my-profile/documents" element={<Documents />} />
              <Route
                path="/my-profile/family-details"
                element={<FamilyDetails />}
              />

              {/* <Route path="/approvals/leavesrequests" element={<Approvals />} /> */}
              <Route path="/approvals/*" element={<Approvals />} />
              {/* <Route path="/approvals/allrequests" element={<Approvals />} />
              <Route path="/approvals/correctionrequests" element={<Approvals />} /> */}
              <Route path="/company-policies/:categoryName?" element={<CompanyPolicies />} />
              <Route path="/ticket/:id" element={<TicketDetail />} />
              <Route path="/tds/*" element={<TDS />} />

              {/* Redirect Unknown Routes */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </div>
  );
};
